












































































import { mapState } from "vuex";
import { Vue, Component, Watch } from "vue-property-decorator";
import { IUserNotification } from "@/models/userNotifications";
import { DataModules } from "@/store/modules/data";
import {
  NotificationStatuses,
  NotificationTypes
} from "@/data/enums/notifications";

@Component({
  components: {
    "user-notification": () =>
      import("@/components/app/global/userNotifications/userNotification.vue")
  },
  computed: {
    ...mapState({
      dataScope(state, getters) {
        return getters[`data/${this.dataModule}/loggedUserScope`]();
      },
      notifications(state, getters) {
        return this.$_.orderBy(
          getters[`data/listArray`]({
            storeModule: this.dataModule,
            scope: this.dataScope
          }),
          "created_at",
          "desc"
        );
      },
      total(state, getters) {
        return getters[`data/total`]({
          storeModule: this.dataModule,
          scope: this.dataScope
        });
      },
      hasUnreadNotifications(state, getters) {
        return getters[`data/${DataModules.USER_NOTIFICATIONS}/hasUnread`]();
      }
    })
  }
})
export default class UserNotificationsList extends Vue {
  public requestError = false;
  public isReloading = false;
  public isLoading = false;
  public dismissAllInProgress = false;
  public offset = 0;
  public dataModule = DataModules.USER_NOTIFICATIONS;
  public statuses = NotificationStatuses;
  public status: "all" | NotificationStatuses = NotificationStatuses.UNREAD;

  // Mapped From State
  public notifications!: IUserNotification[];
  public dataScope!: number;
  public total!: number;
  public readonly hasUnreadNotifications!: boolean;

  public created() {
    this.loadData(false);
  }

  public async loadData(merge: boolean) {
    this.requestError = false;
    this.isLoading = true;
    try {
      await this.$store.dispatch(`data/${this.dataModule}/list`, {
        merge,
        ignoreStored: true,
        scope: this.dataScope,
        params: {
          "filter[message_type]": NotificationTypes.PRIVATE,
          limit: 10,
          offset: this.offset,
          order: "-created_at",
          with: "object",
          ...this.statusFilter
        }
      });
      this.requestError = false;
      this.offset = this.notifications.length;
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
      this.requestError = true;
    } finally {
      this.isLoading = false;
      this.isReloading = false;
    }
  }

  public reloadData() {
    this.isReloading = true;
    this.loadData(false);
  }

  public async dismissAll() {
    try {
      this.dismissAllInProgress = true;
      await this.$store.dispatch(
        `data/${DataModules.USER_NOTIFICATIONS}/dismissAll`
      );
      await Promise.all([
        this.$store.dispatch(
          `data/${DataModules.USER_NOTIFICATIONS}/refreshHasUnread`
        ),
        this.loadData(false)
      ]);
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.dismissAllInProgress = false;
    }
  }

  @Watch("status")
  public statusChanged(newValue, oldValue) {
    if (newValue !== oldValue) {
      this.offset = 0;
    }
    this.loadData(false);
  }

  public get statusFilter() {
    if (this.status === "all") {
      return {};
    }

    return {
      "filter[status]": this.status
    };
  }

  public get hasNotifications() {
    return this.notifications.length > 0;
  }

  public get hasMore() {
    return this.total > this.notifications.length;
  }

  public onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
    const loadMoreHeight = this.$_.get(
      this.$refs,
      "loadMore.$el.clientHeight",
      0
    );
    if (
      this.hasMore &&
      loadMoreHeight + scrollTop + clientHeight >= scrollHeight
    ) {
      this.loadData(true);
    }
  }
  // Methods
  public markAsRead(notification: IUserNotification) {
    this.$store.dispatch(`data/${DataModules.USER_NOTIFICATIONS}/markRead`, {
      notification,
      remove: this.status === NotificationStatuses.UNREAD
    });
  }
}
